import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { MenuComponent, DesktopFixedMenuComponent } from '@cbui/public_api';
import { UtilService } from '@cbcore/services/utils/utils/utils.service';
import { CustomizerComponent } from './components/customizer/customizer.component';
import { HeaderComponent } from './components/header/header';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CommonModule,
    RouterOutlet,
    MenuComponent,
    DesktopFixedMenuComponent,
    CustomizerComponent,
    HeaderComponent,
  ],
})
export class AppComponent {
  private readonly utilService = inject(UtilService);

  ready = true; // Set to true by default since we don't need merchant state
  customizerVisible = false;

  constructor() {
    // No explicit theme forced here: setTheme() falls back to the persisted
    // localStorage['color-theme'] choice, or the OS `prefers-color-scheme`,
    // so returning visitors and the theme switcher's choice both stick.
    this.utilService.setTheme(false);
  }
}
